export default [
  // 申请成为创作者：介绍
  {
    path: '/becomeCreatorIntro',
    name: 'BecomeCreatorIntro', // t('dropdownMenu.BecomeCreatorIntro')
    meta: {
      isKeepAlive: true,
      key: Date.now(),
    },
    component: () =>
      import(/* webpackChunkName: "creator" */ '@/views/becomeCreator/becomeCreatorIntro.vue'),
  },
  {
    path: '/becomeCreatorApply',
    name: 'BecomeCreatorApply',
    meta: {
      isKeepAlive: true,
      key: Date.now(),
    },
    component: () =>
      import(/* webpackChunkName: "creator" */ '@/views/becomeCreator/creatorapply.vue'),
  },
  {
    path: '/loginPhone',
    name: 'LoginPhone',
    meta: {
      needLogin: false,
      isKeepAlive: false,
    },
    component: () => import('@/views/login/loginPhone.vue'),
  },
  {
    path: '/faq',
    name: 'FAQ',
    meta: {
      isKeepAlive: true,
      key: Date.now(),
    },
    component: () => import('@/views/about/FAQ.vue'),
  },
  {
    path: '/kyc',
    name: 'KYC',
    meta: {
      needLogin: true,
      title: 'KYC',
      isKeepAlive: false,
      key: Date.now(),
    },
    component: () => import('@/views/kyc/index.vue'),
  },
  {
    path: '/about',
    name: 'About',
    meta: {
      isKeepAlive: true,
      key: Date.now(),
    },
    component: () => import('@/views/about/index.vue'),
  },
  {
    path: '/ourMission',
    name: 'OurMission',
    meta: {
      isKeepAlive: true,
      key: Date.now(),
    },
    component: () => import('@/views/about/OurMission.vue'),
  },
  {
    path: '/404',
    name: 'NotFound',
    meta: {
      isKeepAlive: true,
      key: Date.now(),
    },
    component: () => import('@/views/error/404.vue'),
  },
  {
    path: '/template',
    name: 'Template',
    component: () => import('@/views/template/index.vue'),
  },
  {
    path: '/partner',
    name: 'Partner',
    meta: {
      isKeepAlive: true,
      key: Date.now(),
    },
    component: () => import('@/views/about/partner.vue'),
  },
  // 教程
  {
    path: '/videoGuide',
    name: 'videoGuide',
    meta: {
      isKeepAlive: true,
      key: Date.now(),
    },
    component: () => import('@/views/about/videoGuide.vue'),
  },
  // 登录loading
  {
    path: '/loading',
    name: 'Loading',
    meta: {
      isKeepAlive: true,
      key: Date.now(),
    },
    component: () => import('@/views/login/loading.vue'),
  },
  {
    path: '/signin',
    name: 'Signin',
    meta: {
      isKeepAlive: true,
      key: Date.now(),
    },
    component: () => import('@/views/login/signin.vue'),
  },
  {
    path: '/signup',
    name: 'Signup',
    meta: {
      isKeepAlive: true,
      key: Date.now(),
    },
    component: () => import('@/views/login/signup.vue'),
  },
  {
    path: '/campaigns',
    name: 'Campaigns', // t('route.Campaigns')
    meta: {
      isKeepAlive: true,
      key: Date.now(),
    },
    component: () => import('@/views/Campaigns/index.vue'),
  },
  {
    path: '/brand',
    name: 'Brand',
    meta: {
      isKeepAlive: true,
      key: Date.now(),
    },
    component: () => import('@/views/about/brand.vue'),
  },
  {
    path: '/pay/:status',
    name: 'Pay',
    meta: {
      key: Date.now(),
    },
    component: () => import('@/views/pay/index.vue'),
  },
  {
    path: '/diagnose',
    name: 'Diagnose',
    meta: {
      isKeepAlive: false,
      key: Date.now(),
    },
    component: () => import('@/views/about/diagnose.vue'),
  },
  // {
  //   path: '/:catchAll(.*)',
  //   redirect: {
  //     name: 'Login',
  //   },
  // },
]
